import { gql } from 'Utils/apolloClient'

const installmentNoteDeleteMutation = gql`
  mutation InstallmentNoteDelete($id: ID!) {
    installmentNoteDelete(input: { id: $id }) {
      success
    }
  }
`

export default installmentNoteDeleteMutation
